<template>
  <div class="login-container">
    <!-- 视频背景 -->
    <div class="video-bg">
      <video
        autoplay
        muted
        playsinline
        preload="auto"
        webkit-playsinline="true"
        x-webkit-airplay="allow"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portraint"
        class="bg-video"
      >
        <source
          src="https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260303/girlHome&1278565&20260303164958.mp4"
          type="video/mp4"
        />
      </video>
    </div>

    <!-- 标题 -->
    <div class="title-section">
      <img
        src="https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260228/girlTitle&30564&20260228163618.png"
        alt="女神节快乐"
        class="title-image"
      />
    </div>
    <!-- 顶部logo -->
    <div class="top-logo">
      <img
        src="https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260228/girlYdTitle&4071&20260228163858.png"
        alt="易点生活"
      />
    </div>

    <!-- 登录 -->
    <div class="form-section">
      <van-form @submit="onSubmit">
        <van-field
          v-model="form.phone"
          type="tel"
          placeholder="请输入您的手机号码"
          left-icon="https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260302/girlPhone&346&20260302094117.png"
          class="custom-field"
        />
        <van-field
          v-model="form.captchaCode"
          type="text"
          left-icon="https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260302/girlYzm&1017&20260302094244.png"
          placeholder="请输入验证码"
          maxlength="6"
          class="custom-field code-field"
        >
          <template #button>
            <div v-if="!timer" @click="!yzmLoading ? getCode() : ''">
              获取验证码
            </div>
            <van-count-down v-else :time="timer" @finish="timer = 0" />
          </template>
        </van-field>
        <van-button
          type="primary"
          block
          native-type="submit"
          loading-text="加载中..."
          :loading="loading"
          color="#000000"
          class="login-btn"
        >
          登录
        </van-button>
      </van-form>
    </div>
  </div>
</template>

<script>
import { girlSendCaptcha, girlLogin } from '@/api/ydGirlsDay'

export default {
  data() {
    return {
      form: {
        phone: '',
        captchaCode: ''
      },
      yzmLoading: false,
      timer: 0,
      loading: false
    }
  },
  mounted() {},
  methods: {
    async getCode() {
      if (!this.form.phone) {
        this.$toast('请输入正确的手机号码')
        return
      }

      try {
        this.yzmLoading = true
        await girlSendCaptcha({
          phone: this.form.phone
        })
        this.yzmLoading = false
        this.timer = 60000
      } catch ({ data }) {
        this.yzmLoading = false
      }
    },
    async onSubmit() {
      try {
        if (!this.form.phone && !this.form.captchaCode) {
          this.$toast('请填手机号验证码！')
          return
        }
        this.loading = true
        const { data } = await girlLogin(this.form)
        this.loading = false
        sessionStorage.setItem('ydGrilsDayToken', data)
        this.$emit('login-success')
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.video-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;

  .bg-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.top-logo {
  position: absolute;
  top: 1.8%;
  left: 15px;
  z-index: 10;

  img {
    width: 103px;
    height: auto;
  }
}

.title-section {
  position: absolute;
  top: 12.5%;
  opacity: 0;
  transform: translateY(-50px);
  animation: titleSlideIn 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  animation-delay: 4s;

  .title-image {
    width: 90%;
    display: block;
    margin: auto;
    height: auto;
  }
}

.form-section {
  position: absolute;
  bottom: 11%;
  width: 80%;
  max-width: 320px;
  opacity: 0;
  transform: translateY(50px);
  animation: formSlideIn 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  animation-delay: 6s;

  .custom-field {
    margin-bottom: 18px;
    border-radius: 25px;
    line-height: 30px;
    font-size: 16px;
    display: flex;
    align-items: center;
    border: 1px solid #424e31;

    :deep(.van-field__left-icon) {
      margin-right: 10px;
    }
  }
}

.login-btn {
  border-radius: 25px;
  height: 50px;
  line-height: 50px;
  font-size: 21px;
}

/* 动画定义 */
@keyframes titleSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes formSlideIn {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
